exports.apiKey = 'AIzaSyAwc3bFCNBUfnEu7m4HnXMSc4eQg30hmUA';

exports.ipcpanel = '128.201.75.116';